import React, { useEffect } from 'react';
import { Network, Users, UserCheck, Briefcase } from 'lucide-react';

const OrganizationChart = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-fixed"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner.jpg)` }}
        >
          <div className="absolute inset-0 bg-slate-900/70"></div>
        </div>
        <div className="relative z-10 text-center px-4 animate-slide-up">
          <span className="text-accent font-bold tracking-widest uppercase mb-4 block">Organization</span>
          <h1 className="text-5xl md:text-6xl font-display font-bold text-white mb-6">조직도</h1>
          <p className="text-xl text-slate-200 max-w-2xl mx-auto font-light">
            효율적이고 체계적인 조직 운영을 통해 최고의 성과를 창출합니다.
          </p>
        </div>
      </section>

      {/* Intro Text */}
      <section className="py-20 bg-slate-50">
        <div className="section-container text-center max-w-4xl mx-auto">
          <Network className="w-12 h-12 text-accent mx-auto mb-6" />
          <h2 className="text-3xl font-display font-bold text-slate-900 mb-6">
            <span className="text-primary">유기적인 협업</span> 시스템
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            파워테크는 각 부서간의 원활한 소통과 협력을 통해 신속한 의사결정 체계를 갖추고 있습니다.<br />
            전문성을 갖춘 인재들이 모여 시너지를 발휘하며 고객 가치를 실현합니다.
          </p>
        </div>
      </section>

      {/* Chart Section */}
      <section className="py-24 bg-white">
        <div className="section-container">
          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 border border-slate-100 transform hover:shadow-[0_20px_60px_-15px_rgba(0,0,0,0.1)] transition-all duration-500">
            <div className="max-w-5xl mx-auto">
              <img
                src={`${process.env.PUBLIC_URL}/images/organization.png`}
                alt="조직도"
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Departments Grid */}
      <section className="py-24 bg-slate-900 text-white">
        <div className="section-container">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-display font-bold">주요 부서 소개</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white/5 border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-all duration-300">
              <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center text-blue-400 mb-6">
                <Briefcase size={24} />
              </div>
              <h3 className="text-xl font-bold mb-3">경영지원팀</h3>
              <p className="text-slate-400">인사, 총무, 회계 등 회사의 전반적인 운영을 지원하고 체계적인 관리 시스템을 구축합니다.</p>
            </div>

            <div className="bg-white/5 border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-all duration-300">
              <div className="w-12 h-12 bg-green-500/20 rounded-lg flex items-center justify-center text-green-400 mb-6">
                <Users size={24} />
              </div>
              <h3 className="text-xl font-bold mb-3">생산관리팀</h3>
              <p className="text-slate-400">생산 계획 수립부터 공정 관리, 납기 준수까지 효율적인 생산 시스템을 운영합니다.</p>
            </div>

            <div className="bg-white/5 border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-all duration-300">
              <div className="w-12 h-12 bg-orange-500/20 rounded-lg flex items-center justify-center text-orange-400 mb-6">
                <UserCheck size={24} />
              </div>
              <h3 className="text-xl font-bold mb-3">품질보증팀</h3>
              <p className="text-slate-400">엄격한 품질 검사와 지속적인 모니터링을 통해 최고의 제품 품질을 보증합니다.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrganizationChart;
